export enum AuthorizationType {
  EVENT_PASSWORD = "event_password",
  TICKET_TYPE_PASSWORD = "ticket_type_password",
  ACCESS_PIN = "access_pin",
}

export interface AuthorizationMetadata {
  eventSlug?: string;
  [key: string]: unknown;
}

export interface AuthorizationResult {
  authorized: boolean;
  authorizations: string[];
  metadata?: Record<string, unknown>;
}

export interface AuthorizationStrategy {
  type: AuthorizationType;
  check(
    resourceId: string,
    isAuthorizedFn: (type: AuthorizationType, resourceId: string) => boolean,
    metadata?: AuthorizationMetadata
  ): Promise<AuthorizationResult>;
  authorize(
    resourceId: string,
    credentials: unknown,
    metadata?: AuthorizationMetadata
  ): Promise<AuthorizationResult>;
  revoke(resourceId: string): Promise<string[]>;
}
